import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CHeader,
  CCardSubtitle,
  CRow,
} from '@coreui/react'
import { FaArrowLeft } from 'react-icons/fa'

export default function DescriptionDetail() {
  const { state } = useLocation()
  // console.log(state)
  return (
    <>
      {/* <div>TemplateDetail</div> */}
      <CContainer fluid>
        <CRow>
          <CCol>
            <CCardGroup>
              <CCard className="p-4">
                <CHeader>
                  <CRow>
                    <CCol>
                      {' '}
                      <Link style={{ color: '#000' }} to={{ pathname: `/admin/safeDescription` }}>
                        <FaArrowLeft />
                      </Link>
                      <span> Description Detail</span>
                    </CCol>
                  </CRow>
                </CHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={1}>
                      <strong>Title (EN):-</strong>
                    </CCol>
                    <CCol>
                      <span>{state?.title_en}</span>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol md={1}>
                      <strong>Title (TH):-</strong>
                    </CCol>
                    <CCol>
                      <span>{state?.title_th}</span>
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol md={1}>
                      <strong>Description (EN):-</strong>
                    </CCol>
                    <CCol>
                      <span dangerouslySetInnerHTML={{ __html: state?.description_en }}></span>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol md={1}>
                      <strong>Description (TH):-</strong>
                    </CCol>
                    <CCol>
                      <span dangerouslySetInnerHTML={{ __html: state?.description_th }}></span>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </>
  )
}
